import { createFileRoute } from '@tanstack/react-router'
import { AssistantSwitch } from '../../../../components/assistant-switch'
import { InvestorHomeRedirect } from '../../../../components/investor-home-redirect'
import { DealFlowArchivePage } from '../../../../features/legacy-investor/deal-flow-archive-page'

// The Deal Flow archive is gone; this address stays for links already sent.
export const Route = createFileRoute('/app/investor/$id/deal-flow_/archive')({
  component: () => (
    <AssistantSwitch assistant={<InvestorHomeRedirect />} classic={<DealFlowArchivePage />} />
  ),
})
